import React, {Component} from 'react';

import {
  API,
  API_URL,
  BASE_URL,
  BROKER_EMAIL,
  BROKER_EMAIL_LOGO,
  BROKER_EMAIL_MASTHEAD,
  BROKER_NAME,
  BROKERID,
  EMAIL_API,
  EMAIL_METHOD,
  ENABLED_CURRENCIES
} from '../../../../config';
import Util from '../../../../util';
import {
  Button, Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  withStyles
} from "@material-ui/core";
import {fuseDark} from '@fuse/fuse-colors'

import classNames from 'classnames';

import {withRouter} from 'react-router-dom';
import styled from "styled-components";

import {translate} from 'react-i18next';
import {withContext} from "../../../custom/StateProvider";

const numeral = require('numeral');
const holdings = API.service('holdings');
const trading_stock = API.service('trading-stock');
const event_trigger = API.service('event-trigger');

const bond_disbursement = API.service('bond-disbursement');
const buy_order = API.service('buy-order');
const sell_order = API.service('sell-order');

const rate_table = API.service("rate-table");
const wallet = API.service("wallet");

const axios = require('axios');
const qs = require('qs');

const m = require('moment-timezone');

const styles = theme => ({
  rootContainer: {
    width: '35%',
    background: '#0071a5',
    padding: 0,
    paddingLeft: 25,
    borderLeft: '1px solid #595b5f',
    maxWidth: '601px',

    '@media (max-width: 1540px)': {
      width: '30%'
    },
    '@media (max-width: 1380px)': {
      width: '30%'
    }
  },
  flexBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  margin20: {
    margin: 20,
  },
  margin10: {
    margin: 10,
  },
  vertlabel: {
    msTransform: 'rotate(180deg)',
    webkitTransform: 'rotate(180deg)',
    transform: 'rotate(180deg)',
    color: 'rgba(255,255,255,0.7)'
  },
  tableHeader: {
    background: '#3c4250',
    height: 30,
  },
  tableRow: {
    marginTop: 3,
    background: '#225a7a',
    height: 30,
  },
  bottomTag: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 50,
    border: '1px solid #2a2e36',
    width: '50%',
  },
  tag: {
    position: 'relative',
    height: 50,
    fontSize: 12,
    fontFamily: 'Myriad',
    background: '#158eb5',
    width: '25%',
    border: '0.5px solid #1d7291',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',

    '&.first': {
      background: '#19648a',
    },
  },

  tagselling: {
    position: 'relative',
    height: 50,
    fontSize: 12,
    fontFamily: 'Myriad',
    background: '#158eb5',
    width: '50%',
    border: '0.5px solid #1d7291',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',

    '&.first': {
      background: '#19648a',
    },
  },

  menu: {
    padding: 5,
  },
  cancelButton: {
    background: 'red',
    color: 'white',
    width: '100%',
    height: 20,
    padding: 0,
    fontSize: 10,
    minHeight: 20,
  },
  container: {
    background: '#17668d',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'space-between',
  },
  fontTypo: {
    fontFamily: 'ProximaNovaLight',
    fontSize: 16
  },
  walletHeadRow: {
    backgroundColor: 'rgba(255,255,255,0.4)',
    textAlign: 'center',
    padding: '5px',
  },
  walletHead: {
    backgroundColor: 'rgba(0,0,0,0.2)',
    padding: '4px 10px',
    borderRadius: '10px',
    display: 'inline-block'
  },
  notice: {
    marginTop: 20,
    color: 'white',
    textAlign: 'center',
    padding: 10,
    fontSize:'14px'
  },
  tradeContainerStyle: {
    color: 'white',
    padding: 20,
    height: '100%',
    width:'520px',

    '@media (max-width: 1680px)': {
      padding: 10,
    }
  },
  errorField: {
    '& > div': {
      border: '1px solid red !important',
      backgroundColor:'rgba(255,0,0,0.5)',
    }
  }

});

const SwitchButton = styled.div`
	color: white;
	background: #17668d;
	border-radius: 4px;
	border: 0.75px solid #2a2e36;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 50%;

	&.active {
		color: white;
		background: #1ea7ed;
		border-color: white;
	}
`;

class BuySell extends Component {

  constructor(props) {
    super(props);

    this.state = {
      company_order: false,
      qty: '',
      qty_s: '',
      currency: '',
      symbol: '',
      price: '',
      buyorsell: 'Buy',
      orderError: false,
      select: 'F',
      currency_selector: 'usd',
      sel: 1,
      minSell:0,
      maxBuy:99999999,
      selectedCompany: this.props.selectedCompany,
      payload:{},
      emailSent:false,
      qtyError:false,
      PCTBuy:'',
      expiry:1,
      dayDiff:23,
      buy_rate:1.5,
      sell_rate:1.5,
    }
  }

  handleFieldChange = (e) => {
    var key = e.target.id;
    var value = e.target.value;
    var obj = {};
    obj[key] = value;
    this.setState(obj);
  }
  resetValues = () => {
    this.setState({
      qty: '',
      qty_s: '',
      price: '',
      PCTBuy:'',
      qtyError:false
    });
  }

  handleKeyDown = (e) => {
    const decimal_index = e.target.value.indexOf('.');
    if (decimal_index > -1) {
      var decimal = e.target.value.substring(decimal_index, e.target.value.length + 1);
      if (decimal.length > 3 && e.keyCode !== 8) {
        e.preventDefault();
      }
    }
  }

  handlePriceChange = (e) => {
    if ((!(/^[A-Za-z]+$/.test(e.target.value)) && /^\d+\.?\d{0,3}$/.test(e.target.value)) || e.target.value === '')
      this.setState({
        price: e.target.value,
        orderValue: this.state.qty * e.target.value
      });
  }

  handlePCTChange = (e) => {
    if ((!(/^[A-Za-z]+$/.test(e.target.value)) && /^\d+\.?\d{0,3}$/.test(e.target.value)) || e.target.value === '')
      this.setState({
        price: (e.target.value / 100),
        orderValue: (this.state.qty / this.props.selectedCompany.denomination) * (e.target.value / 100) * this.props.selectedCompany.denomination,
        PCTBuy: e.target.value
      });
  }

  handleQtyChange = (e) => {
    if (e.target.value === '')
      return this.setState({ qty_s: '' });

    this.setState({
      qty_s: Util.addThousandCommas(e.target.value, '0,0'),
      qty: numeral(e.target.value)._value,
      orderValue: numeral(e.target.value) * this.state.price
    })
  }

  handleDropdownChange = (e) => {
    this.setState({ select: e.target.value });
  }

  handleExpiryChange = (e) => {
    this.setState({ expiry: e.target.value });
  }

  updateBalance() {
    //var hh = 0;
    /*holdings.find({query:{_investor_account:this.props.investor._account, _company_account:this.props.selectedCompany.account_number}}).then(h=>{
        if(h.total >= 1) {
            h.data.forEach(hl => {
                hh = hh + hl._quantity;
                this.setState({
                    holdings: hh
                })
            })
        } else {
            this.setState({
                holdings: 0
            })
        }
    })*/

    if (this.props.selectedCompany.currency === 'USD') {
      this.setState({
        currency: 'USD',
        symbol: '$',
        currency_selector: 'usd'
      })
    } else if (this.props.selectedCompany.currency === 'GBP') {
      this.setState({
        currency: 'GBP',
        symbol: '£',
        currency_selector: 'gbp'
      })
    } else if (this.props.selectedCompany.currency === 'IPO') {
      this.setState({
        currency: 'IPO',
        symbol: '$',
        currency_selector: 'ipo'
      })
    } else if (this.props.selectedCompany.currency === 'ANG') {
      this.setState({
        currency: 'XCG',
        symbol: 'Cg',
        currency_selector: 'xcg'
      })
    } else if (this.props.selectedCompany.currency === 'XCG') {
      this.setState({
        currency: 'XCG',
        symbol: 'Cg',
        currency_selector: 'xcg'
      })
    }else if (this.props.selectedCompany.currency === 'EUR') {
      this.setState({
        currency: 'EUR',
        symbol: '€',
        currency_selector: 'eur'
      })
    }
  }

  updateTopandTail = () => {
    buy_order.find({query:{_company_account:this.props.selectedCompany.account_number, _investor_account: this.props.investor._account, $sort:{_price:-1}, _status:0,$limit:1}}).then(b =>{
      sell_order.find({query:{_company_account:this.props.selectedCompany.account_number, _investor_account: this.props.investor._account, $sort:{_price:1}, _status:0,$limit:1}}).then(s =>{
        this.setState({
          maxBuy: (s.total >= 1) ? (parseFloat(s.data[0]._price )).toFixed(2) : 9999999999,
          minSell: (b.total >= 1) ? (parseFloat(b.data[0]._price)).toFixed(2) : 0
        })
      })
    })

    if(this.props.selectedCompany.share_type==='D'){
      axios.get(API_URL + '/clock').then(c => {
        const changes = (c.data.state === 'OPEN') ? c.data.closes_at : c.data.opens_at;
        let expiry = m(changes).tz('America/Curacao');

        bond_disbursement.find({
          query: {
            company_account: this.props.selectedCompany.account_number,
            disbursement_date: {$lt: m().format('YYYY-MM-DD')},
            $sort:{disbursement_date : -1},
            $limit: 1
          }
        }).then(d => {
          if(d.total !== 0) {
            //let days_diff = expiry.diff(m(d.data[0].disbursement_date), 'days');
            let days_diff = Util.YEARFRAC(expiry.format('YYYY-MM-DD'), m(d.data[0].disbursement_date).format('YYYY-MM-DD'), 0);
            console.log("diff:",days_diff);
            console.log("selected_company:",this.props.selectedCompany.account_number);
            this.setState({
              dayDiff: days_diff
            })
          }
        });
      });
    }
  }

  componentDidMount() {
  const app = this;

    this.updateBalance();
    /*
    holdings.on("created", c=>{
        if(c._investor_account === this.props.investor._account._account){
            this.updateBalance();
        }
    })

    holdings.on("updated", c=>{
        if(c._investor_account === this.props.investor._account._account){
            this.updateBalance();
        }
    })*/

    rate_table.find({
      query: {
        effective_date: {$lt: new Date()},
        investor_type:'general',
        rate_type:'buy_trade',
        $limit: 1
      }
    }).then(b => {
      app.setState({
        buy_rate:b.data[0].rate,
      })
    })

    rate_table.find({
      query: {
        effective_date: {$lt: new Date()},
        investor_type:'general',
        rate_type:'sell_trade',
        $limit: 1
      }
    }).then(s => {
      app.setState({
        sell_rate:s.data[0].rate,
      })
    })

    this.updateTopandTail();

    event_trigger.on('created', e => {
      this.updateBalance();
    });

    wallet.on('created', e => {
      this.updateBalance();
    });

    this.timer = setInterval(()=>{
      this.updateTopandTail()
    },4000);
  }

  componentWillReceiveProps(nextProps) {
    this.updateBalance();
    if (nextProps.selectedCompany) {
      const { selectedCompany } = nextProps;
      if (this.state.sel !== selectedCompany.id) {
        console.log(selectedCompany);
        this.setState({ sel: selectedCompany.id });
        this.resetValues();
        this.updateTopandTail();
      }

    }
    //        this.setState({ price: nextProps.selectedCompany.share_price });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  toggleBuySell = () => {
    if (this.state.buyorsell === 'Buy') {
      buy_order.find({query:{_company_account:this.props.selectedCompany.account_number, _investor_account: this.props.investor._account, $sort:{_price:-1}, _status:0,$limit:1}}).then(o =>{
        this.setState({
          buyorsell: 'Sell',
          minSell: (o.total >= 1) ? (parseFloat(o.data[0]._price)).toFixed(2) : 0
        })
      })

    } else {
      sell_order.find({query:{_company_account:this.props.selectedCompany.account_number, _investor_account: this.props.investor._account, $sort:{_price:1}, _status:0,$limit:1}}).then(o =>{
        this.setState({
          buyorsell: 'Buy',
          maxBuy: (o.total >= 1) ? (parseFloat(o.data[0]._price)).toFixed(2) : 9999999999
        })
      })
    }
  };

  resendVerification = () => {
    const app = this;
    //this.props.investor
    if( !(this.props.investor._states & 2)){
      var emailConfirmationHash = Util.md5('ebaebf123' + this.props.investor._email + this.props.investor._firstname + ' ' + this.props.investor._surname);

      if(EMAIL_METHOD === 'legacy') {
        axios.post(EMAIL_API, qs.stringify({
          apiKey: 'v857ybn90845bn4578y459n7',
          action: 'doSendRegistrationEmail',
          fromAddress: BROKER_EMAIL,
          fromAddressName: BROKER_NAME + ' Account Creation',
          toAddress: this.props.investor._email,
          subject: '-',
          message: '-',
          emailVerificationUrl: BASE_URL + '/verifyemail/' + this.props.investor._email + '/' + emailConfirmationHash,
          clientName: this.props.investor._firstname + ' ' + this.props.investor._surname
        }));
        app.setState({
          emailSent: true
        });
      } else {
        axios.post(EMAIL_API + '/requests', {
            sender: 'Investor Portal',
            payload: {
              transportName: 'sendgrid',
              to: this.props.investor._email,
              from: BROKER_EMAIL,
              subject: 'Registration Email Verification',
              templateName: 'registration',
              data: {
                broker_email: BROKER_EMAIL,
                broker_name: BROKER_NAME,
                email_masthead: BROKER_EMAIL_MASTHEAD,
                email_logo: BROKER_EMAIL_LOGO,
                language: this.props.lng,
                base_url: BASE_URL,
                emailVerificationUrl: BASE_URL + '/verifyemail/' + this.props.investor._email + '/' + emailConfirmationHash,
                clientName: this.props.investor._firstname + ' ' + this.props.investor._surname
              }
            }
          }
        ).then(function (data) {
          app.setState({
            emailSent: true
          });
        })
      }
    };
  };

  submitOrder = () => {
    const controller = this;

    //alert('clicked continue');
    console.log(this.state.payload);

    controller.setState({
      processing: true,
      dialog: false,
    });
    if(this.state.buyorsell === "Sell"){
      sell_order.create(this.state.payload).then(p => {
        controller.setState({
          orderPopup: "hidden",
          orderError: 'Order Placed Successfully',
          qty: 0,
          processing: false,
        },function(){
          //this.props.closeDialog()
        });
        //this.props.closeDialog()
        window.setTimeout(() => {
          controller.clearError();
          controller.resetValues();
          controller.props.context.update({
            popupContent: false,
            updateOrders: true
          })
        }, 2000);
      });
    } else {
      buy_order.create(this.state.payload).then(p => {
        controller.setState({
          orderPopup: "hidden",
          orderError: 'Order Placed Successfully',
          qty: 0,
          processing: false,
        },function(){
          //this.props.closeDialog()
        });

        window.setTimeout(() => {
          controller.clearError();
          controller.resetValues();
          controller.props.context.update({
            popupContent: false,
            updateOrders: true
          })
        }, 2000);
      })
    }
  }

  closeDialog = () => {
    this.setState({
      dialog: false
    })
  }


  processOrder = (ev) => {
    ev.stopPropagation();
    const controller = this;
    const {t} = this.props;
    if((this.props.selectedCompany.share_type === 'D') && ((this.state.qty % this.props.selectedCompany.denomination) > 0) ){
      this.setState({
        orderError: t('user_panel_bond_qty_funds')
      })
      window.setTimeout(controller.clearError, 4000);
      return false;
    }
    if ((parseFloat(this.state.price).toFixed(3)) > 0.000 && (parseInt(this.state.qty,10)) > 0) {
      trading_stock.find({query:{_company_account: this.props.selectedCompany.account_number, $limit:1}}).then(cc =>{
        if(this.state.buyorsell === "Sell"){
          if(controller.state.price > this.state.minSell) {
            holdings.find({
              query: {
                _company_account: this.props.selectedCompany.account_number,
                _investor_account: this.props.investor._account,
                _type: 'FREE',
                _quantity: {
                  $gte: parseInt(this.state.qty,10),
                }
              }
            }).then(hc => {
              if (hc.total > 0) {
                var payload = {
                  'trading_instrument': this.props.selectedCompany.account_number,
                  'amount': parseInt(controller.state.qty,10),
                  'type': (this.props.selectedCompany.share_type !== 'D') ? controller.state.select : 'F',
                  "expiry": this.state.expiry,
                  "investor_account": controller.props.investor._account,
                  "share_type": this.props.selectedCompany.share_type,
                  "accrued_interest": (this.props.selectedCompany.share_type !== 'D') ? 0 : (((this.props.selectedCompany.bond_yield / 100) / 360) * (this.state.dayDiff + 2) * this.state.qty),
                  "broker_account": BROKERID,
                  "price": parseFloat(controller.state.price).toFixed(3),
                  "target_account": 0,
                  "currency": this.props.selectedCompany.currency,
                  "fee_rate": this.state.sell_rate,
                }
                this.setState({
                  payload:payload
                });

                //this.submitOrder();

                this.setState({
                  dialog: (<React.Fragment>
                    <DialogTitle id="alert-dialog-title">{t('user_panel_placement_heading')}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        {t('user_panel_placement_placing_in')} {(this.state.buyorsell === "Buy") ? t('user_panel_trade_buying') : t('user_panel_trade_selling')} {t('user_panel_placement_order_for')} {Util.addThousandCommas(this.state.qty, 0)} @ {this.state.symbol}{Util.addThousandCommas(parseFloat(this.state.price))} {this.state.currency} {t('user_panel_placement_in')} {this.props.selectedCompany.symbol}, {t('user_panel_placement_totalling')} {this.state.symbol}{Util.addThousandCommas(parseFloat(((controller.state.qty * controller.state.price) - ((controller.state.qty * controller.state.price) * (this.state.sell_rate / 100))).toFixed(2)))} {t('user_panel_placement_fees')}
                        <br/>
                        <b>{t('user_panel_placement_continue')}</b>
                      </DialogContentText>
                    </DialogContent>
                    {(this.state.processing) &&
                    <DialogActions>
                      {t('user_panel_placement_processing')}
                    </DialogActions>
                    }
                    {(!this.state.processing) &&
                    <DialogActions>
                      <Button style={{color: 'white', background: 'red'}} onClick={this.closeDialog}
                              color="primary">
                        {t('user_panel_placement_cancel')}
                      </Button>
                      <Button style={{color: 'white', background: 'green'}} onClick={this.submitOrder} color="primary"
                              autoFocus>
                        {t('user_panel_placement_continue_btn')}
                      </Button>
                    </DialogActions>
                    }
                  </React.Fragment>)
                });


                //var d = [];
                //d = JSON.stringify(payload)

                //var formData = new FormData();
                //formData.append("json",d);
                //console.log('---',controller.state);
                //console.log(parseInt(controller.state.qty));
                //console.log(d);

                /*axios.post(TRADINGBRIDGE, formData).then(c=>{
                    controller.setState({
                        orderPopup: "hidden",
                        orderError:'Order Placed',
                        qty:0
                    });
                    this.resetValues();
                    window.setTimeout(controller.clearError,5000);
                })*/;

              } else {
                this.setState({
                  orderError: 'Insufficient Holdings to Process this Order'
                })
                window.setTimeout(controller.clearError, 4000);
              }
            });
          } else {
            this.setState({
              orderError: 'Invalid or conflicting order placement'
            });
            window.setTimeout(controller.clearError, 4000);
          }
        } else if (this.state.buyorsell === "Buy"){
          if(controller.state.price < this.state.maxBuy) {
            if (parseFloat(this.props.balances[controller.state.currency_selector].balance) >= ((parseInt(controller.state.qty,10) * parseFloat(controller.state.price)) * (1+(this.state.buy_rate / 100)))) {
              var payload = {
                'trading_instrument': this.props.selectedCompany.account_number,
                'amount': parseInt(controller.state.qty,10),
                'type': (this.props.selectedCompany.share_type !== 'D') ? controller.state.select : 'F',
                "expiry": this.state.expiry,
                "accrued_interest": (this.props.selectedCompany.share_type !== 'D') ? 0 : (((this.props.selectedCompany.bond_yield / 100) / 360) * (this.state.dayDiff + 2) * this.state.qty),
                "investor_account": controller.props.investor._account,
                "share_type": this.props.selectedCompany.share_type,
                "broker_account": BROKERID,
                "price": parseFloat(controller.state.price).toFixed(3),
                "target_account": 0,
                "currency": this.props.selectedCompany.currency,
                "fee_rate": this.state.buy_rate,
              };

              this.setState({
                payload:payload
              });

              //this.submitOrder();
              this.setState({
                dialog: (<React.Fragment>
                  <DialogTitle id="alert-dialog-title">{t('user_panel_placement_heading')}</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      {t('user_panel_placement_placing_in')} {(this.state.buyorsell === "Buy") ? t('user_panel_trade_buying') : t('user_panel_trade_selling')} {t('user_panel_placement_order_for')} {Util.addThousandCommas(this.state.qty, 0)} @ {this.state.symbol}{Util.addThousandCommas(parseFloat(this.state.price))} {this.state.currency} {t('user_panel_placement_in')} {this.props.selectedCompany.symbol}, {t('user_panel_placement_totalling')} {this.state.symbol}{Util.addThousandCommas(parseFloat(((controller.state.qty * controller.state.price) * (1 + (this.state.buy_rate / 100))).toFixed(2)))} {t('user_panel_placement_fees')}
                      <br/>
                      <b>{t('user_panel_placement_continue')}</b>
                    </DialogContentText>
                  </DialogContent>
                  {(this.state.processing) &&
                  <DialogActions>
                    {t('user_panel_placement_processing')}
                  </DialogActions>
                  }
                  {(!this.state.processing) &&
                  <DialogActions>
                    <Button style={{color: 'white', background: 'red'}} onClick={this.closeDialog}
                            color="primary">
                      {t('user_panel_placement_cancel')}
                    </Button>
                    <Button style={{color: 'white', background: 'green'}} onClick={this.submitOrder} color="primary"
                            autoFocus>
                      {t('user_panel_placement_continue_btn')}
                    </Button>
                  </DialogActions>
                  }
                </React.Fragment>)
              })

            } else {
              if(!this.checkQtyForBonds){
                this.setState({
                  orderError: t('user_panel_bond_qty_funds')
                })
              } else {
                this.setState({
                  orderError: t('user_panel_trade_error_funds')
                })
              }
              window.setTimeout(controller.clearError, 4000);
            }
          } else {
            this.setState({
              orderError: t('user_panel_trade_error_conflict')
            })
            window.setTimeout(controller.clearError, 4000);
          }
        }
      })
      //this.props.addTrade("add");
    } else if(!this.checkQtyForBonds) {
    }  else if((parseInt(this.state.qty,10)) === 0 || isNaN(parseInt(this.state.qty,10))){
      this.setState({
        orderError:t('user_panel_trade_error_zero_stock'),
      })
      window.setTimeout(controller.clearError,4000);
      //this.resetValues();
    } else if ( (parseFloat(this.state.price).toFixed(3)) === 0.000 || (parseFloat(this.state.price)) === 0.000 || isNaN(parseFloat(this.state.price))){
      this.setState({
        orderError: t('user_panel_trade_error_zero_value'),
      })

      window.setTimeout(controller.clearError,4000);
      //this.resetValues();
    }
  }

  clearError = () => {
    this.setState({
      orderError: false
    })
  }

  checkQtyForBonds = () => {
    if(this.props.selectedCompany.share_type === 'D') {
      if((this.state.qty % this.props.selectedCompany.denomination) > 0){
        this.setState({
          qtyError:true
        })
        return false;
      } else {
        this.setState({
          qtyError:false
        })
        return true;
      }
    } else {
      return true;
    }
    // eslint-disable-next-line
    return true;
  }

  checkValue = (e) => {
    this.checkQtyForBonds();
  }

  render() {
    const { classes, t } = this.props;
    const price = parseFloat(this.state.price)
    const qty = this.state.qty
    const fee = this.state.buyorsell === 'Buy' ? 1+(this.state.buy_rate/100) : 1-(this.state.sell_rate/100);
    const amount = price * qty
    const total = (this.props.selectedCompany.share_type !== 'D') ? amount * fee || 0 : (amount * fee) + (((this.props.selectedCompany.bond_yield / 100) / 365) * this.state.dayDiff * this.state.qty);

    return (
      <div className={classes.tradeContainerStyle}>
        <div className={classes.container}>
          <div style={{ width: '22%', fontSize: 12, fontFamily: 'Myriad' }}>
            <SwitchButton onClick={this.toggleBuySell} className={(this.state.buyorsell === 'Buy') ? 'active' : ''}>{t('user_panel_trade_buy')}</SwitchButton>
            <SwitchButton onClick={this.toggleBuySell} className={(this.state.buyorsell === 'Sell') ? 'active' : ''}>{t('user_panel_trade_sell')}</SwitchButton>
          </div>
          <div className={classes.margin10}>
            <div className={classes.flexBox}>
              <TextField
                className={(this.state.qtyError) ? classNames(classes.textField, classes.errorField) : classNames(classes.textField)}
                value={this.state.qty_s < 0 ? '' : this.state.qty_s}
                variant="outlined"
                id="qty"
                placeholder={t('user_panel_trade_order')}
                onChange={this.handleQtyChange}
                InputProps={{
                  style: {
                    color: 'white',
                    borderRadius: 4,
                    fontSize: 10,
                    padding: 5,
                  }
                }}
                // eslint-disable-next-line
                inputProps={{
                  style: {
                    padding: 5,
                  }
                }}
                InputLabelProps={{
                  style: {
                    fontSize: 10,
                    color: 'white',
                  },
                }}
                onBlur={this.checkValue}
              />
              {(this.props.selectedCompany.share_type !== 'D') &&
              <TextField
                className={classes.textField}
                value={this.state.price < 0 ? '' : this.state.price}
                variant="outlined"
                style={ {marginLeft:5} }
                onChange={this.handlePriceChange}
                id={'price'}
                placeholder={t('user_panel_trade_units_at') + t('user_panel_trade_max')}
                InputProps={{
                  style: {
                    color: 'white',
                    borderRadius: 4,
                    fontSize: 10,
                    padding: 5
                  },
                }}
                // eslint-disable-next-line
                inputProps={{
                  style: {
                    padding: 5,
                  }
                }}
                InputLabelProps={{
                  style: {
                    fontSize: 12,
                    color: 'white',
                  },
                }}
              />
              }
              {(this.props.selectedCompany.share_type === 'D') &&
              <TextField
                className={classes.textField}
                value={this.state.PCTBuy < 0 ? '' : this.state.PCTBuy}
                variant="outlined"
                style={{marginLeft: 5}}
                onChange={this.handlePCTChange}
                id={'price'}
                placeholder={t('user_panel_trade_pct')}
                InputProps={{
                  style: {
                    color: 'white',
                    borderRadius: 4,
                    fontSize: 10,
                    padding: 5
                  },
                }}
                // eslint-disable-next-line
                inputProps={{
                  style: {
                    padding: 5,
                  }
                }}
                InputLabelProps={{
                  style: {
                    fontSize: 12,
                    color: 'white',
                  },
                }}
              />
              }
            </div>
            {(this.props.selectedCompany.share_type === 'D') &&
            <div style={{textAlign: 'left', fontSize:'0.7em', marginTop:'4px'}}>
              Must be multiple of {Util.addThousandCommas(this.props.selectedCompany.denomination)}
            </div>
            }
            <TextField
              select
              style={{ width: '100%', marginTop: 5 }}
              className={classes.textField}
              value={this.state.select}
              onChange={this.handleDropdownChange}
              SelectProps={{
                native: true,
                MenuProps: {
                  className: classes.menu,
                },
                style: {
                  color: 'white',
                  borderRadius: 4,
                  fontSize: 12,
                  padding: 5,
                  height: 35,
                },
              }}
              margin='normal'
              variant="outlined"
            >
              <option value={'execute'} style={{ backgroundColor: '#17668d' }} disabled>
                {t('user_panel_execute_as')}
              </option>

              <option value={'F'} style={{backgroundColor: '#17668d', paddingLeft: 10}}>
                {t('user_panel_trade_all_or_nothing')}
              </option>
              {(this.props.selectedCompany.share_type !== 'D') &&
              <option value={'P'} style={{backgroundColor: '#17668d', paddingLeft: 10}}>
                {t('user_panel_trade_partial')}
              </option>
              }
            </TextField>
            <TextField
              select
              style={{ width: '100%', marginTop: 5 }}
              className={classes.textField}
              value={this.state.expiry}
              onChange={this.handleExpiryChange}
              SelectProps={{
                native: true,
                MenuProps: {
                  className: classes.menu,
                },
                style: {
                  color: 'white',
                  borderRadius: 4,
                  fontSize: 12,
                  padding: 5,
                  height: 35,
                },
              }}
              margin='normal'
              variant="outlined"
            >
              <option value={'execute'} style={{ backgroundColor: '#17668d' }} disabled>
                {t('user_panel_expire_at')}
              </option>
              {(this.props.selectedCompany.share_type !== 'D') &&
              <option value={'1'} style={{backgroundColor: '#17668d', paddingLeft: 10}}>
                {t('user_panel_trade_persist')}
              </option>
              }
              <option value={'2'} style={{ backgroundColor: '#17668d', paddingLeft: 10 }}>
                {t('user_panel_trade_end_of_day')}
              </option>
            </TextField>
          </div>
          <div style={{ paddingTop: 10, paddingBottom: 10 }}>
            {
              (this.props.selectedCompany.status !== "2" && this.props.selectedCompany.status !== "6" && this.props.selectedCompany.status !== "5" && this.props.selectedCompany.status !== "4" && ((this.props.investor._states & 128) !== 0) && ENABLED_CURRENCIES.indexOf(this.props.selectedCompany.currency) >= 0) &&
              <Button style={{
                background: "#009320",
                color: 'white',
                marginRight: 5,
                padding: '16px 15px',
                textTransform: 'uppercase'
              }}
                      onClick={this.processOrder}
              >
                {(this.state.buyorsell === 'Buy') ? t('user_panel_trade_place_buy_order') : t('user_panel_trade_place_sell_order')}
              </Button>
            }
          </div>
        </div>
        {(this.state.orderError) &&
        <div className={classes.notice} style={(this.state.orderError === "Order Placed Successfully") ? { backgroundColor: '#009320' } : { backgroundColor: 'red' }}>{this.state.orderError}</div>
        }
        <div className={classes.flexBox} style={{ marginTop: 20 }}>
          <div className={(this.state.buyorsell === 'Buy') ? classNames(classes.tag, 'first') : classNames(classes.tagselling, 'first')}>
            <span style={{ textAlign: 'center', color: 'white' }}>{(this.state.buyorsell === "Buy") ? t('user_panel_trade_buying') : t('user_panel_trade_selling')} {this.props.selectedCompany.symbol}</span>
            {(total > 0) &&
            <span style={{ color: 'white', fontWeight: 'bold' }}>{Util.addThousandCommas(qty)} @ {this.state.symbol}{Util.addThousandCommas(price)} {this.state.currency}</span>
            }
          </div>
          <div className={(this.state.buyorsell === 'Buy') ? classNames(classes.tag) : classNames(classes.tagselling)}>
            <span style={{ fontWeight: 'bold' }}>{t('user_panel_trade_total')}</span>
            {(total >= 0) &&
            <span style={{ fontWeight: 'bold' }}>{this.state.symbol}{Util.addThousandCommas(total.toFixed(2))}</span>
            }
          </div>
          {(this.state.buyorsell) === 'Buy' &&
          <React.Fragment>
            <div className={classes.tag}>
              <span style={{ textAlign: 'center', fontWeight: 'bold' }}>{t('user_panel_trade_available_funds')}</span>
              <span style={{ textAlign: 'center', fontWeight: 'bold' }}>{this.state.symbol}{Util.addThousandCommas(this.props.balances[this.state.currency_selector].balance.toFixed(2))}</span>
            </div>
            <div className={classes.tag}>
              <span>{(this.props.balances[this.state.currency_selector].balance - total) < 0 ? t('user_panel_trade_deficit') : t('user_panel_trade_remaining')}</span>
              {(total >= 0) &&
              <span style={(this.props.balances[this.state.currency_selector].balance - total < 0) ? { color: 'red', fontWeight: 'bold' } : { color: 'white' }}>
                    {this.state.symbol}{Util.addThousandCommas((this.props.balances[this.state.currency_selector].balance - total).toFixed(2))}</span>
              }
            </div>
          </React.Fragment>
          }
        </div>
        <div className={classes.flexBox} style={{ marginTop: 3, textAlign: 'center' }}>
          <div style={{ fontSize: 12, width: '100%', textAlign: 'center', color:'black'}}>
            * {t('user_panel_trade_includes_fees_of')} {Math.abs((fee - 1.0).toFixed(4) * 100)}%
            {(this.props.selectedCompany.share_type==='D' && this.state.qty !== 0 && this.state.qty !== '') &&
            <br />
            }
            {(this.props.selectedCompany.share_type === 'D' && this.state.qty !== 0 && this.state.qty !== '') &&
            <span>and Accrued interest of  {this.state.symbol}{Util.addThousandCommas(((this.props.selectedCompany.bond_yield / 100) / 360) * (this.state.dayDiff + 2) * this.state.qty)}</span>
            }
          </div>
        </div>
        {
          (this.props.selectedCompany.status === "2" && this.props.investor._states & 128 && ENABLED_CURRENCIES.indexOf(this.props.selectedCompany.currency) >= 0) &&
          <div style={{ background: 'rgba(255,0,0,0.6)', border: '1px solid red', borderRadius: '5px', padding: '4px 15px', textAlign: 'center', marginBottom: '10px', top: 0, bottom: -11, left: 0, position: 'absolute', right: -1, zIndex: 1000, fontSize: '29px', paddingTop: 80 }}>{t('user_panel_trade_error_1_suspended')}<br />{t('user_panel_trade_error_2_suspended')}</div>
        }
        {
          (this.props.selectedCompany.status === "5" && this.props.investor._states & 128 && ENABLED_CURRENCIES.indexOf(this.props.selectedCompany.currency) >= 0) &&
          <div style={{ background: 'rgba(0,255,0,0.6)', border: '1px solid #009320', borderRadius:'5px', padding:'4px 15px', textAlign:'center', marginBottom:'10px',top:0, bottom:-11,left:0,position:'absolute',right:-1,zIndex:1000,fontSize:'29px',paddingTop:80}}>{t('user_panel_trade_error_1_listed')} <br /></div>
        }

        {
          (this.props.selectedCompany.status === "6" && this.props.investor._states & 128 && ENABLED_CURRENCIES.indexOf(this.props.selectedCompany.currency) >= 0) &&
          <div style={{ background: 'rgba(0,255,0,0.6)', border: '1px solid #009320', borderRadius:'5px', padding:'4px 15px', textAlign:'center', marginBottom:'10px',top:0, bottom:-11,left:0,position:'absolute',right:-1,zIndex:1000,fontSize:'29px',paddingTop:80}}>{t('user_panel_trade_error_1_pretrade')} <br /></div>
        }

        {
          (this.props.selectedCompany.status === "4" && this.props.investor._states & 128 && ENABLED_CURRENCIES.indexOf(this.props.selectedCompany.currency) >= 0) &&
          <div style={{ background: 'rgba(255,176,68,0.6)', border: '1px solid #009320', borderRadius:'5px', padding:'4px 15px', textAlign:'center', marginBottom:'10px',top:0, bottom:-11,left:0,position:'absolute',right:-1,zIndex:1000,fontSize:'29px',paddingTop:80}}>{t('user_panel_trade_error_1_halted')} <br /> {t('user_panel_trade_error_2_halted')}</div>
        }

        {(ENABLED_CURRENCIES.indexOf(this.props.selectedCompany.currency) === -1 && this.props.investor._states & 128) &&
        <div style={{background:'rgba(0,255,0,0.6)',border:'1px solid green', borderRadius:'5px',padding:'4px 15px',textAlign:'center', marginBottom:'10px',top:0, bottom:-11,left:0,position:'absolute',right:-1,zIndex:1000,fontSize:'29px',paddingTop:80}}>{t('user_panel_trade_error_1_currency')}<br /> {t('user_panel_trade_error_2_currency')}</div>
        }

        {(!(this.props.investor._states & 128) ) &&
        <div style={{ background: 'rgba(255,0,0,0.8)', border: '1px solid red', borderRadius: '5px', padding: '4px 15px', textAlign: 'center', marginBottom: '10px', top: 0, bottom: -11, left: 0, position: 'absolute', right: -1, zIndex: 1000, fontSize: '29px', paddingTop: 36 }}>
          {(!(this.props.investor._states & 2)) &&
          <React.Fragment>
            {t('user_panel_trade_error_1_email')}<br /><br />
            {(this.state.emailSent === false) &&
            <Button style={{background: fuseDark.colGreen, color: 'white', marginRight: 5, padding: '16px 15px', textTransform: 'uppercase'}} onClick={this.resendVerification}>{t('user_panel_trade_error_2_email')}</Button>
            }
            {(this.state.emailSent) &&
            <p style={{fontSize:'0.6em'}}>{t('user_panel_trade_error_3_email')}</p>
            }
          </React.Fragment>
          }

          {( (this.props.investor._states & 2) !== 0 ) &&
          <React.Fragment>
            {t('user_panel_trade_error_1_kyc')}<br />
            <Button style={{background: fuseDark.colGreen, color: 'white', marginRight: 5, padding: '16px 15px', textTransform: 'uppercase'}} onClick={()=>{this.props.history.push('/profile')}}>{t('user_panel_trade_error_2_kyc')}</Button>
          </React.Fragment>
          }
        </div>
        }
        {this.state.dialog &&
        <Dialog open={this.state.dialog}>
          {this.state.dialog}
        </Dialog>
        }
      </div>
    )
  }
}

export default withContext(withStyles(styles, { withTheme: true })(withRouter(translate('translations')(BuySell))));
